import Divider from './ant';

export default Divider;
